<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :destroyOnClose="true"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="docCode"
        :columns="columns"
        :pagination="false"
        :dataSource="dataSource"
        :loading="confirmLoading"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleSeeMoreClick(record)">预览</a>
          <a-divider type="vertical" />
          <a @click="handleDownLoad(record)">下载</a>
        </span>
      </a-table>
    </a-spin>
  </a-modal>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
  data() {
    return {
      title: '详情',
      visible: false,
      confirmLoading: false,
      dataSource: [],
      columns: [
        {
          title: '序号',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '文件名',
          align: 'center',
          dataIndex: 'fileName'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    open(ddCode) {
      if (!ddCode && ddCode !== 0) {
        this.$message.error('找不到订单号，请联系开发人员！')
        return
      }
      this.visible = true
      this.confirmLoading = true
      this.dataSource = []
      getAction('/base/ftpFileInfo/wzhImageList', { ddCode })
        .then(res => {
          if (res.code == 200) {
            this.dataSource = res.result
            return
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => (this.confirmLoading = false))
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    handleSeeMoreClick(record) {
      window.open(record.fileUrl, '_blank')
    },
    handleDownLoad(filesObj) {
      let suffixStr = ''
      let fileName = ''
      if (filesObj.fileUrl.indexOf('?') > 0) {
        //华云的文件
        let arrListTemp = filesObj.fileUrl.split('?')
        let arrListTemp1 = arrListTemp[0].split('.')
        suffixStr = arrListTemp1[arrListTemp1.length - 1]
      } else {
        //泗阳文件  非华云
        let arrListTemp = filesObj.fileUrl.split('.')
        suffixStr = arrListTemp[arrListTemp.length - 1]
      }
      if (!suffixStr) {
        this.$message.error('找不到文件名后缀！')
        fileName = filesObj.fileName
      } else {
        fileName = filesObj.fileName + '.' + suffixStr
      }
      var request = new XMLHttpRequest()
      request.responseType = 'blob'
      let fileUrl = filesObj.fileUrl // 文件路径
      console.log(fileUrl);
      console.log(window._CONFIG['staticDomainURL']);
      window.open(fileUrl, "_blank");
      request.open('GET', fileUrl)
      request.onload = function() {
        var url = window.URL.createObjectURL(this.response)
        var a = document.createElement('a')
        document.body.appendChild(a)
        console.log(url);
        a.href = url
        a.download = fileName
        a.click()
      }
      request.send()
    }
  }
}
</script>

<style lang="less" scoped></style>
